import React from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
// import toast from "react-hot-toast";
import { useState } from "react";

import {
  FiUser,
  FiPhone,
  FiMail,
  FiGlobe,
  FiSend,
  FiGift,
  FiFileText,
  FiCheckCircle,
  FiUsers,
  FiChevronDown,
  FiMessageSquare,
} from "react-icons/fi";
import { FaDatabase } from "react-icons/fa6";
import { SlCalender } from "react-icons/sl";
import { LuCalendarClock, LuListTodo, LuMapPinned } from "react-icons/lu";
import { LuUserRoundCheck } from "react-icons/lu";
import { MdMobileScreenShare } from "react-icons/md";
import { MdCircleNotifications } from "react-icons/md";
import { SiGoogleforms } from "react-icons/si";

import { HiOutlineOfficeBuilding } from "react-icons/hi";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
const features = [
  {
    title: "Payroll Management",
    icon: <FaDatabase className="w-5 h-5" />,
    link: "/payroll-management",
  },
  {
    title: "Attendance Management",
    icon: <SlCalender className="w-5 h-5" />,
    link: "/attendance-management",
  },
  {
    title: "Shift Management",
    icon: <LuCalendarClock className="w-5 h-5" />,
    link: "/shift-management",
  },
  {
    title: "Leave Management",
    icon: <LuUserRoundCheck className="w-5 h-5" />,
    link: "/leave-management",
  },
  {
    title: "Task Management",
    icon: <LuListTodo className="w-5 h-5" />,
    link: "/task-management",
  },
  {
    title: "Geo-Location Attendance",
    icon: <LuMapPinned className="w-6 h-6" />, // slightly larger
    link: "/geo-location-attendance",
  },
  {
    title: "Selfie-Based Attendance",
    icon: <MdMobileScreenShare className="w-6 h-6" />, // Material icons need a bit larger
    link: "/selfie-based-attendance",
  },
  {
    title: "Reminder Management",
    icon: <MdCircleNotifications className="w-6 h-6" />,
    link: "/reminder-management",
  },
  {
    title: "Tax & Forms Management",
    icon: <SiGoogleforms className="w-5 h-5" />,
    link: "/tax-form-management",
  },
];

const demoOptions = [
  "All in One",
  "HRMS",
  "Project",
  "Payroll",
  "ATS",
  "EMS",
  "Performance",
  "Field Force",
];

const employeeOptions = ["1-10", "11-25", "26-50", "51-100", "100+"];

export default function ContactSection() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      fullName: "",
      company: "",
      phone: "",
      email: "",
      employees: "",
      website: "",
      message: "",
      demorequest: "",
    },
  });
  const selectedEmployee = watch("employees");
  const phone = watch("phone");
  const selecteddemorequest = watch("demorequest");

  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const payload = {
        fullName: data.fullName,
        company: data.company,
        phone: data.phone,
        email: data.email,
        website: data.website,
        noOfEmployees: data.employees,
        message: data.message,
        demorequest: data.demorequest,
      };

      const response = await axios.post(
        `${import.meta.env.VITE_APIBASE_URL}` + "/contact-us",
        payload,
      );

      if (response.data.success) {
        // toast.success("Message sent successfully.");
        // Swal.fire({
        //   icon: "success",
        //   title: "Request Submitted",
        //   text: response.data.message,
        //   confirmButtonColor: "#10324F",
        // });
        navigate("/thank-you-contact");
        reset();

        setValue("phone", "");
      } else {
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text: "Please try again later.",
          confirmButtonColor: "#10324F",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: response.data.message || "Please try again later.",
        confirmButtonColor: "#10324F",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="w-full bg-[#d3e0eb] py-10 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 items-start">
          {/* ================= LEFT ================= */}

          <div>
            <h1 className="text-2xl lg:text-3xl font-bold leading-tight text-[#10324F]">
              Let's Build a Better
              <br />
              Workplace with
              <span className="text-[#10324F]"> Waggex</span>
            </h1>

            {/* TOP CARDS */}

            <div className="grid sm:grid-cols-3 gap-2 mt-4 bg-transparent pt-6 pb-6 pl-2 pr-2 rounded-2xl shadow-lg border border-white">
              <div className="flex gap-2">
                <div className="w-10 h-10 rounded-2xl bg-white flex items-center justify-center text-[#10324F] shadow-[0_6px_20px_rgba(13,59,93,0.15)]">
                  <FiGift size={18} />
                </div>

                <div>
                  <h2 className="font-bold text-sm">No Credit Card</h2>

                  <p className="text-gray-700 text-xs mt-1">
                    Get started instantly
                  </p>
                </div>
              </div>

              <div className="flex gap-2">
                <div className="w-10 h-10 rounded-2xl bg-white flex items-center justify-center text-[#10324F] shadow-[0_6px_20px_rgba(13,59,93,0.15)]">
                  <FiFileText size={18} />
                </div>

                <div>
                  <h2 className="font-bold text-sm">Free 5 Employees</h2>

                  <p className="text-gray-700 text-xs mt-1">For new account</p>
                </div>
              </div>

              <div className="flex gap-2">
                <div className="w-10 h-10 rounded-2xl bg-white flex items-center justify-center text-[#10324F] shadow-[0_6px_20px_rgba(13,59,93,0.15)]">
                  <FiCheckCircle size={18} />
                </div>

                <div>
                  <h2 className="font-bold text-sm">100% Free Account</h2>

                  <p className="text-gray-700 text-xs mt-1">
                    No hidden charges
                  </p>
                </div>
              </div>
            </div>
            <div className="hidden md:block">
              <h2 className="text-2xl font-bold text-[#10324F] mt-8">
                All-in-One HR & Payroll Platform
              </h2>

              {/* FEATURES */}
              <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-8 mt-4">
                {features.map((item, index) => (
                  <div key={index} className="flex items-center gap-4">
                    <div className="shrink-0 w-12 h-12 flex items-center justify-center rounded-lg border border-white bg-transparent">
                      <span className="text-[#10324F]">{item.icon}</span>
                    </div>

                    <div>
                      <h2 className="text-lg sm:text-sm font-normal text-[#10324F] leading-5">
                        {item.title}
                      </h2>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ================= RIGHT FORM ================= */}

          <div className="bg-transparent rounded-3xl shadow-xl border border-white p-6 ">
            <h2 className="text-2xl font-bold text-[#0F2851]">Get in Touch</h2>

            <p className="text-[#10324F] mt-3 mb-4">
              Fill out the form and we'll get back to you shortly.
            </p>

            <form onSubmit={handleSubmit(onSubmit)}>
              {/* Full Name */}

              <div className="grid md:grid-cols-2 gap-5 mb-2">
                <div>
                  <div className="relative">
                    <FiUser
                      className="absolute left-4 top-1/2 -translate-y-1/2 text-[#10324F]"
                      size={20}
                    />

                    <input
                      type="text"
                      placeholder="Enter your full name"
                      className={`w-full h-10 border rounded-xl pl-12 pr-4 outline-none transition bg-white placeholder:text-[#52667d]
      ${
        errors.fullName
          ? "border-red-500"
          : "border-gray-300 focus:border-gray-500"
      }`}
                      {...register("fullName", {
                        required: "Full name is required",
                      })}
                    />
                  </div>

                  {errors.fullName && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.fullName.message}
                    </p>
                  )}
                </div>
                <div>
                  <div>
                    <div className="relative">
                      <FiMail
                        className="absolute left-4 top-1/2 -translate-y-1/2 text-[#10324F]"
                        size={20}
                      />

                      <input
                        type="email"
                        placeholder="Enter your email"
                        className={`w-full h-10 border rounded-xl pl-12 pr-4 outline-none bg-white placeholder:text-[#52667d]
        ${
          errors.email
            ? "border-red-500"
            : "border-gray-300 focus:border-gray-500"
        }`}
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Enter valid email",
                          },
                        })}
                      />
                    </div>

                    {errors.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.email.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Company */}

              <div className="grid md:grid-cols-2 gap-5 mb-2">
                <div>
                  <div className="relative">
                    <HiOutlineOfficeBuilding
                      className="absolute left-4 top-1/2 -translate-y-1/2 text-[#10324F]"
                      size={20}
                    />

                    <input
                      type="text"
                      placeholder="Enter company name"
                      className={`w-full h-10 border rounded-xl pl-12 pr-4 outline-none bg-white placeholder:text-[#52667d]
      ${
        errors.company
          ? "border-red-500"
          : "border-gray-300 focus:border-gray-500"
      }`}
                      {...register("company", {
                        required: "Company name is required",
                      })}
                    />
                  </div>

                  {errors.company && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.company.message}
                    </p>
                  )}
                </div>
                <div>
                  <div
                    className={`flex items-center h-10 border rounded-xl overflow-hidden bg-white  ${
                      errors.phone
                        ? "border-red-500"
                        : "border-gray-300 focus-within:border-gray-500"
                    }`}
                  >
                    {/* Phone Icon */}
                    {/* <div className="pl-4">
                        <FiPhone className="text-gray-400" size={18} />
                      </div> */}

                    {/* Country Code */}
                    <div className="px-3 text-[#10324F] border-r border-gray-300 select-none text-sm font-medium">
                      +91
                    </div>

                    {/* Phone Input */}
                    <input
                      type="text"
                      maxLength={10}
                      placeholder="Enter your number"
                      value={phone}
                      className="flex-1 h-full px-4 outline-none pl-2 placeholder:text-[#52667d]"
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setValue("phone", value, {
                          shouldValidate: true,
                        });
                      }}
                    />
                  </div>

                  {/* Hidden RHF Input */}
                  <input
                    type="hidden"
                    {...register("phone", {
                      required: "Phone number is required",
                      minLength: {
                        value: 10,
                        message: "Enter valid phone number",
                      },
                      maxLength: {
                        value: 10,
                        message: "Enter valid phone number",
                      },
                    })}
                  />

                  {errors.phone && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.phone.message}
                    </p>
                  )}
                </div>
              </div>
              {/* Employee & Website */}

              <div className="grid md:grid-cols-2 gap-5 mb-2">
                <div>
                  <label className="block font-medium mb-2 text-[#10324F] sr-only">
                    Website
                  </label>

                  <div className="relative">
                    <FiGlobe
                      className="absolute left-4 top-1/2 -translate-y-1/2 text-[#10324F]"
                      size={20}
                    />

                    <input
                      type="url"
                      placeholder="Enter website"
                      className={`w-full h-10 border rounded-xl pl-12 pr-4 outline-none bg-white   placeholder:text-[#52667d] ${
                        errors.website
                          ? "border-red-500"
                          : "border-gray-300 focus:border-gray-500"
                      }`}
                      {...register("website", {
                        required: "Website is required",
                        pattern: {
                          value: /^(https?:\/\/)?([\w\d-]+\.)+\w{2,}(\/.*)?$/,
                          message: "Enter valid website",
                        },
                      })}
                    />
                  </div>

                  {errors.website && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.website.message}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="employees"
                    className="block font-medium mb-2 text-[#10324F] sr-only"
                  >
                    Number of Employees
                  </label>
                  <div className="relative">
                    <FiUsers
                      size={20}
                      className="absolute left-5 top-1/2 -translate-y-1/2 text-[#10324F]"
                    />
                    <select
                      id="employees"
                      aria-required="true"
                      className={`w-full h-10 rounded-xl border ${
                        errors.phone ? "border-red-500" : "border-white"
                      } pl-14 pr-4 outline-none appearance-none focus:ring-0 focus:border-white transition bg-white   placeholder:text-[#52667d]
                    ${selectedEmployee ? "text-[#10324F]" : "text-[#52667d]"}
                    ${
                      errors.employees
                        ? "border-red-500"
                        : "border-gray-200 focus:border-[#10324F]"
                    }`}
                      {...register("employees", {
                        required: "Employee Size is required",
                      })}
                    >
                      <option value="">Employee Size</option>

                      {employeeOptions.map((item) => (
                        <option
                          key={item}
                          value={item}
                          className="text-[#10324F]"
                        >
                          {item}
                        </option>
                      ))}
                    </select>
                    <FiChevronDown
                      size={18}
                      className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[#10324F]"
                    />
                  </div>

                  {errors.employees && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.employees.message}
                    </p>
                  )}
                </div>
              </div>

              {/* Message */}
              <div>
                <label
                  htmlFor="bookdemo"
                  className="block font-medium mb-2 text-[#10324F] sr-only"
                >
                  Book Demo
                </label>
                <div className="relative">
                  <FiMessageSquare
                    size={20}
                    className="absolute left-5 top-1/2 -translate-y-1/2 text-[#10324F]"
                  />
                  <select
                    id="demorequest"
                    className={`w-full h-10 rounded-xl border bg-white placeholder:text-gray-700 pl-14 pr-4 outline-none appearance-none focus:ring-0 focus:border-white transition 
    ${selecteddemorequest ? "text-[#10324F]" : "text-gray-700"}
    ${
      errors.demorequest
        ? "border-red-500"
        : "border-gray-200 focus:border-[#10324F]"
    }`}
                    {...register("demorequest", {
                      required: "Demo request  is required",
                    })}
                  >
                    <option value="" className="text-gray-700">
                      Book demo
                    </option>

                    {demoOptions.map((item) => (
                      <option
                        key={item}
                        value={item}
                        className="text-[#10324F]"
                      >
                        {item}
                      </option>
                    ))}
                  </select>
                  <FiChevronDown
                    size={18}
                    className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[#10324F]"
                  />
                </div>

                {errors.demorequest && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.demorequest.message}
                  </p>
                )}
              </div>
              <div className="mb-4 mt-2">
                <label className="block font-medium mb-2 text-[#10324F]">
                  Description / Message
                  <span className="text-red-500">*</span>
                </label>

                <textarea
                  rows={2}
                  placeholder="Tell us about your requirement..."
                  className={`w-full border rounded-xl p-4 resize-none outline-none bg-white   placeholder:text-[#52667d]
    ${
      errors.message
        ? "border-red-500"
        : "border-gray-300 focus:border-gray-500"
    }`}
                  {...register("message", {
                    required: "Message is required",
                    minLength: {
                      value: 10,
                      message: "Minimum 10 characters",
                    },
                  })}
                />

                {errors.message && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.message.message}
                  </p>
                )}
              </div>

              <button
                type="submit"
                disabled={loading}
                className={`w-full h-10 rounded-xl text-white font-semibold text-lg flex items-center justify-center gap-3 transition

${loading ? "bg-[#10324F] cursor-not-allowed" : "bg-[#10324F] hover:bg-[#10324F]"}
`}
              >
                {loading ? (
                  <>
                    <svg
                      className="animate-spin h-5 w-5"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="white"
                        strokeWidth="3"
                        opacity=".3"
                      />
                      <path
                        d="M22 12a10 10 0 0 1-10 10"
                        stroke="white"
                        strokeWidth="3"
                      />
                    </svg>
                    Sending...
                  </>
                ) : (
                  <>
                    Send Message
                    <FiSend />
                  </>
                )}
              </button>

              <p className="text-center text-gray-700 text-sm mt-5">
                🔒 Your information is safe with us. We respect your privacy.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
